import { useContext } from 'react'
import { UiContext } from './context'

export function useUiState() {
  const context = useContext(UiContext)
  if (!context) throw new Error('No ui context has been defined.')
  return context
}
